import React, { createContext, useContext, useState } from "react";
import { Toast } from "../components/ui/Toast/Toast";

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};

/**
 * Toast Provider
 * Provides toast notification functionality throughout the application
 * Uses SAP UI5 Toast component for consistent UX
 */
export const ToastProvider = ({ children }) => {
  const [toastMessage, setToastMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const showToast = (message) => {
    // If already open, close first then reopen with new message
    if (isOpen) {
      setIsOpen(false);
      setTimeout(() => {
        setToastMessage(message);
        setIsOpen(true);
      }, 100); // Small delay to ensure toast closes before reopening
    } else {
      setToastMessage(message);
      setIsOpen(true);
    }
  };

  const showSuccess = (message) => {
    showToast(`✓ ${message}`);
  };

  const showError = (message) => {
    showToast(`✗ ${message}`);
  };

  const showInfo = (message) => {
    showToast(`ℹ ${message}`);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <ToastContext.Provider
      value={{ showToast, showSuccess, showError, showInfo }}
    >
      {children}
      <Toast open={isOpen} onAfterClose={handleClose}>
        {toastMessage}
      </Toast>
    </ToastContext.Provider>
  );
};
